module.exports = __webpack_public_path__ + "img/CV.Utilities.Telecoms.4_way_comms_ducts.77c7a916.png";